import CTGService from '@/service/category-chk'
export default {
  getListCtg ({commit}, payload) {
    return new Promise((resolve, reject) => {
      CTGService.getListCategory().then(res => {
        commit('getListCtg', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  create ({commit}, payload) {
    return new Promise((resolve, reject) => {
      CTGService.createCtg(payload.ctg).then(res => {
        resolve(res.data.data)
        commit('createCtg', res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  selectCtg ({commit}, payload) {
    return new Promise((resolve, reject) => {
      CTGService.selectCtg(payload.ctg, payload.chks).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },
  destroyCtg ({commit}, payload) {
    return new Promise((resolve, reject) => {
      CTGService.destroyCtg(payload.ctg).then(res => {
        commit('destroyCtg', res.data.data)
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  },

  updateCtg ({commit}, payload) {
    return new Promise((resolve, reject) => {
      CTGService.updateCtg(payload.ctg).then(res => {
        resolve(res.data.data)
      }).catch(errors => {
        reject(errors)
      })
    })
  }

}



// WEBPACK FOOTER //
// ./src/store/module/category-chk/actions.js